const steps = [
  {
    n: "1",
    title: "Sign up & connect Google Ads",
    body: "Start your 7-day free trial. Connect your Google Ads account (or MCC) via one OAuth screen. Agencies: bind each client to its own sub-account.",
  },
  {
    n: "2",
    title: "Add Upfixe to Claude",
    body: "Paste the MCP URL into Claude, ChatGPT (Business / Enterprise / Edu) or Perplexity. Under 60 seconds.",
    snippet: "https://app.upfixe.com/mcp",
  },
  {
    n: "3",
    title: "Tell Claude about your business",
    body: "Upfixe scrapes your homepage and builds a 9-section value-prop doc: elevator pitch, ICP, problems solved, services & pricing, USP, taglines. Edit it by chat any time.",
  },
  {
    n: "4",
    title: "Describe the campaign you want",
    body: '"$50/day plumber campaign in Austin, target CPA $40." Upfixe pulls real Keyword Planner data, filters against your CPA, themes into ad groups, writes RSA copy from your value-prop doc, adds negatives.',
  },
  {
    n: "5",
    title: "Review, then publish — paused",
    body: "You approve in chat. Upfixe ships the campaign to your Google Ads account paused. Nothing spends until you flip the switch in the Google Ads UI.",
  },
  {
    n: "6",
    title: "Edit & report by chat",
    body: '"Pause the brand-research ad group." "Bump the daily budget to $80." "How did we do last week?" Live edits, lifetime reporting, multi-brand views — all by chat.',
  },
];

const McpHowItWorks = () => {
  return (
    <section className="py-20 px-4 bg-muted/30 border-b border-border">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            From zero to live campaign in four minutes
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            One-time setup is a couple of minutes. Each new campaign after that
            takes about 90 seconds.
          </p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step) => (
            <li
              key={step.n}
              className="rounded-lg border border-border bg-background p-6 flex flex-col"
            >
              <div className="h-9 w-9 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold mb-4">
                {step.n}
              </div>
              <h3 className="font-semibold text-lg mb-2">{step.title}</h3>
              <p className="text-sm text-muted-foreground flex-grow">
                {step.body}
              </p>
              {step.snippet && (
                <pre className="mt-4 rounded-md bg-muted px-3 py-2 text-xs font-mono text-foreground overflow-x-auto">
                  {step.snippet}
                </pre>
              )}
            </li>
          ))}
        </ol>

        {/* Video Embed */}
        <div className="mt-14 max-w-4xl mx-auto">
          <div className="text-center mb-6">
            <h3 className="text-2xl font-bold text-foreground">
              Watch Upfixe MCP in Action
            </h3>
            <p className="text-sm text-muted-foreground mt-1">
              Watch an end-to-end search campaign built, refined, and published paused to Google Ads via AI chat terminal without opening a browser.
            </p>
          </div>
          <div className="aspect-video rounded-2xl overflow-hidden border border-border shadow-xl bg-black">
            <iframe
              src="https://www.youtube-nocookie.com/embed/e1tZ_8QwdTA?rel=0"
              title="Control Google Ads from AI Chat with Upfixe MCP"
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <p className="mt-6 text-sm text-muted-foreground leading-relaxed">
            In the walkthrough above, the whole session runs inside Perplexity — no dashboard, no separate login. A quick "what's my account status?"
            confirms the plan, the connected Google Ads account, and recent drafts. From there, one prompt ("run a campaign for Lawyers Online,
            £300/day, £100 target CPA, England, English") is enough for the Upfixe Ads MCP server to pull real Google Ads Keyword Planner data,
            group it into five themed ad groups (high commercial intent, solutions & category, pain points, features, competitors), write RSA
            headlines and descriptions for each, and hand back a campaign ready to review. Nothing spends until you explicitly say "publish to
            Google Ads" — and even then it lands in your account paused, so enabling spend stays a manual step you take in the Google Ads UI itself.
          </p>
        </div>
      </div>
    </section>
  );
};

export default McpHowItWorks;
